import ReconnectingWebSocket from "reconnecting-websocket";
// import { WebSocketUrl } from "../config/index";
import store from "../store/index";
import {
	selectPackageListByQuery,
	//   queryOrderByUseId,
	getMinChatLinkCountsServiceIp,
} from "../network/api";

var websocket = null;
import { ElNotification, ElMessage } from "element-plus";
import Company from "../config";

export const InitWebSocket = () => {
	const reateLinkAndSendheartBeat = () => {
		let message = initNullMessagePojo();
		message.type = "create_link";
		websocket.send(JSON.stringify(message));
		setInterval(() => {
			let _message = initNullMessagePojo();
			_message.type = "heartbeat_check";
			websocket.send(JSON.stringify(_message));
		}, 10000);
	};

	const initNullMessagePojo = () => {
		let ymUserMessage = {
			id: "",
			fromUid: "",
			toUid: "",
			groupId: "",
			status: 0,
			contents: "",
			type: 0,
			client: "",
			ip: "",
			createTime: 0,
			receiveTime: 0,
		};

		let message = {
			type: "",
			ymUserMessage,
			ext: "",
			token: localStorage.getItem("token"),
		};
		return message;
	};

	// 向Store推送消息
	const pushStoreData = (data, type) => {
		const carParkId = data.carParkId;
		if (type === "out") store.commit("SETOUT", data);
		if (type === "in") store.commit("SETIN", data);
		// 判断是用来选择哪个停车场 就推哪个停车场的图片
		if (carParkId === store.getters.carParkId) {
			if (type === "out") {
				store.commit("SETOUTIMAGE", {
					outImage: data.outBigImageUrl,
					outSmallImage: data.outSmallImageUrl,
				});
			} else {
				store.commit("SETINIMAGE", {
					inImage: data.inBigImageUrl,
					inSmallImage: data.inSmallImageUrl,
				});
			}
		}
	};
	// 获取账单信息
	// const getQueryOrderByUseId = async (carParkUseLog) => {
	//     const { data, code } = await queryOrderByUseId(carParkUseLog.id);
	//     if (code != 10002) return
	//     if(store.state.globalConfig.promptChargeOutCar){
	//         if(data.ymOrder.amountsPayable > 0){
	//             pushStoreData(data,'out')
	//         }
	//     }else{
	//         pushStoreData(data,'out')
	//     }

	//     if (data.cfCouponList != "" && data.cfCouponList.length > 0) {
	//         data.ymOrder.couponDenomination =
	//             data["cfCouponList"][0]["denomination"];
	//     } else {
	//         data.ymOrder.couponDenomination = 0;
	//     }

	//     if (
	//         data.ymOrder.amountsPayable - data.ymOrder.couponDenomination > 0 &&
	//         data.ymOrder.status == 0 &&
	//         !data.ymOrder.collectionShopId && data.ymOrder.payTime === 0 && carParkUseLog.payTime === 0
	//     ) {
	//         store.commit('SETCHARGECAR', data)
	//     }
	// }

	const pushOut = (carParkUseLog) => {
		if (store.state.globalConfig.promptChargeOutCar) {
			if (carParkUseLog.ymOrder.amountsPayable > 0) {
				pushStoreData(carParkUseLog, "out");
			}
		} else {
			pushStoreData(carParkUseLog, "out");
		}
		if (carParkUseLog.ymOrder &&
			Number(carParkUseLog.ymOrder.amountActuallyPaid) &&
			carParkUseLog.ymOrder.status == 0 &&
			carParkUseLog.payTime == 0
		) {
			store.commit("SETCHARGECAR", carParkUseLog);
		} else if (carParkUseLog.outReleaseType === '0') {
			store.commit("SETCHARGECAR", carParkUseLog);
		}
	};

	const updateInterface = async (message) => {
		if (message == null) return;
		//修改消息状态为已读
		let consumptionData = initNullMessagePojo();
		consumptionData.type = "change_status";
		consumptionData.ymUserMessage.id = message.ymUserMessage.id;
		consumptionData.ymUserMessage.toUid = message.ymUserMessage.toUid;
		websocket.send(JSON.stringify(consumptionData));
		// 将数据放到页面中进行展示
		let carParkUseLog = JSON.parse(message.ymUserMessage.contents);
		if (message.ymUserMessage.type == 1) {
			if (carParkUseLog.inTime > 0 && carParkUseLog.outTime == 0) {
				pushStoreData(carParkUseLog, "in");
				// this.nowInBigImage = carParkUseLog.inBigImage;
				// const {data} = await selectPackageListByQuery({
				// 	page: 1, size: 1,
				// 	carParkId: carParkUseLog.carParkId,
				// 	numberPlate: carParkUseLog.numberPlate,
				// });
				// carParkUseLog.cfCarParkCarType =
				// 	data == null
				// 		? {name: "临时车", typeCode: 0}
				// 		: data[0].cfCarParkCarType;
				// pushStoreData(carParkUseLog, "in");
			}
			// 更新界面:包括 图片 消息 更新到页面
			// 只提示选中停车场的停车数据
			if (carParkUseLog.carParkId == store.getters.carParkId) {
				const direction =
					carParkUseLog.outTime == 0 ? " 车牌进场：" : "车牌出场：";
				const outCheckPointName = carParkUseLog.outTime == 0 ? carParkUseLog.inCheckPointName : carParkUseLog.outCheckPointName;
				if (store.state.globalConfig.promptEntryExitCar) {
					ElNotification({
						title: "提示",
						message:
							outCheckPointName +
							direction +
							carParkUseLog?.numberPlate,
						position: "bottom-left",
						type: "warning",
					});
				}
			}

			// 出场查询账单
			if (carParkUseLog.outTime > 0) {
				// getQueryOrderByUseId(carParkUseLog);
				pushOut(carParkUseLog);
			} else if (carParkUseLog.inReleaseType === '0' && carParkUseLog.inTime > 0) {
				store.commit("setNotEntered", carParkUseLog);
			}
		} else if (message.ymUserMessage.type == 6) {
			store.commit("SetLicenseplateCorrection", {
				show: true,
				data: message,
			});
		} else {
			// 用户已支付 取消弹窗
			store.commit("PAIDCAR", carParkUseLog);
			// this.$refs.ChargeBox.deleteData(carParkUseLog);
		}
	};

	// const getWsUrl = () => {

	// }

	if (window.WebSocket) {
		getMinChatLinkCountsServiceIp().then((res) => {
			if (res.code != 10002) {
				ElMessage.error(res.message);
				return;
			}
			websocket = new ReconnectingWebSocket(Company.wssUrl + '/gt-ws');
			websocket.onopen = (e) => {
				reateLinkAndSendheartBeat();
			};

			// 接受webSocket消息
			websocket.onmessage = (e) => {
				var message = JSON.parse(e.data);
				// 将数据放到页面中进行展示
				updateInterface(message);
			};

			websocket.onclose = (e) => {
			};
		});
	} else {
		alert("您的浏览器不支持webSocket！");
	}
};
